import initAccordion from "../../common/initAccordions.js";

export default () => {
  document.querySelectorAll(".js-accordion").forEach((el, i) => {
    if (!el.parentElement.classList.contains("js-accordion-group")) {
      initAccordion(el, i);
    }
  });
};
